import { css } from 'linaria';

export const signSection = css`
  && {
    margin-bottom: 0;
  }
`;

export const signTitle = css`
  @media (--only-desktop) {
    display: none;
  }

  @media (--only-desktop) {
    padding-bottom: 50px;
  }
`;

export const signTitleDesktop = css`
  display: none;

  @media (--only-desktop) {
    display: block;
  }
`;

export const bathroomBenefitsReview = css`
  margin-bottom: 48px;

  @media (--only-desktop) {
    margin-bottom: 32px;
  }

  @media (--to-desktop) {
    margin-bottom: 24px;
  }
`;

export const bathroomBenefitsReviewButton = css`
  margin-bottom: 68px;

  @media (--only-mobile) {
    width: 100%;
    margin-bottom: 50px;
  }
`;

export const bathroomReviewsLink = css`
  display: inline-block;
  border-bottom: 2px solid var(--control-accent);

  &:hover {
    background-color: var(--brand-dark);
    border-radius: var(--rounding-m) var(--rounding-m) 0 0;
  }
`;
